import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import routes from '../../../routes';
import { AuthInterceptor } from '../../../constants/AuthInterceptor';
import * as AdminActions from '../../../redux/actions/Admin';
import { encoded } from '../../../utils';

import {
  PageLoadingComponent,
  SubMenuComponent,
  SEOComponent,
} from '../../../component/base';

const HomeBaseComponent = ({ titlePrefix = 'Buskes', moduleKey = 'Account' }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authorizationSubMenuList = useSelector((state) => state.admin.authorizationSubMenuList);

  const [isLoading, setIsLoading] = useState(true);
  const [subMenuData, setSubMenuData] = useState([]);

  const currentRoute = routes?.find(route =>
    matchPath(route.path, location.pathname)
  );

  const fetchAuthorizationSubMenuList = useCallback(() => {
    if (!currentRoute?.home) return;

    setIsLoading(true);
    dispatch(
      AdminActions.GetSubMenuData(
        encoded(
          JSON.stringify({
            main_menu: currentRoute.home,
          })
        )
      )
    );
  }, [dispatch, currentRoute]);

  useEffect(() => {
    window.scrollTo(0, 0);
    AuthInterceptor();
    setSubMenuData([]);
    dispatch(AdminActions.empty_message());
    fetchAuthorizationSubMenuList();
  }, [fetchAuthorizationSubMenuList]);

  useEffect(() => {
    if (authorizationSubMenuList && Object.keys(authorizationSubMenuList).length > 0) {
      setIsLoading(false);
      setSubMenuData(authorizationSubMenuList)
      dispatch(AdminActions.empty_message());
    }
  }, [authorizationSubMenuList, dispatch]);

  return (
    <>
      <SEOComponent
        title={`${titlePrefix} | ${moduleKey} Home`}
        description={`${moduleKey} Home`}
        type="website"
      />

      {isLoading ? (
        <PageLoadingComponent isLoading={isLoading} />
      ) : (
        <div>
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 2xl:col-span-9">
              <div className="grid grid-cols-12 gap-6">
                {/* BEGIN: General Report */}
                <div className="col-span-12 mt-8">
                  <div className="intro-y flex items-center h-10">
                    <h2 className="text-lg font-medium truncate mr-5">
                      {currentRoute?.home} Home
                    </h2>
                  </div>

                  <SubMenuComponent
                    authorizationSubMenuList={subMenuData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeBaseComponent;
